// Central API configuration
// Detects environment automatically
const normalizeApiBase = (value) => {
  const trimmed = value.replace(/\/+$/, '');
  return trimmed.endsWith('/api') ? trimmed : `${trimmed}/api`;
};

const getApiBaseUrl = () => {
  // In Docker build, the REACT_APP_API_URL is baked in at build time
  if (process.env.REACT_APP_API_URL) {
    return normalizeApiBase(process.env.REACT_APP_API_URL);
  }

  // Fallback for local development
  return 'http://localhost:5002/api';
};

export const API_BASE = getApiBaseUrl();

/** Base URL for image uploads. In production, set REACT_APP_UPLOADS_URL if uploads are served from a different origin (e.g. CDN or main domain). */
const UPLOADS_BASE =
  typeof process.env.REACT_APP_UPLOADS_URL !== 'undefined' && process.env.REACT_APP_UPLOADS_URL !== ''
    ? process.env.REACT_APP_UPLOADS_URL.replace(/\/+$/, '')
    : API_BASE.replace(/\/api\/?$/, '');

/**
 * Build full URL for an image path (team, case-studies, blog uploads).
 * Production: set REACT_APP_API_URL (and optionally REACT_APP_UPLOADS_URL) so images load from your API server.
 */
export function getImageUrl(path) {
  if (!path || typeof path !== 'string') return null;
  const trimmed = path.trim().replace(/\\/g, '/');
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;
  if (trimmed.startsWith('uploads/') || trimmed.startsWith('/uploads/')) {
    const uploadPath = trimmed.startsWith('/') ? trimmed.slice(1) : trimmed;
    return `${UPLOADS_BASE}/${uploadPath}`;
  }
  const publicUrl = typeof process.env.PUBLIC_URL === 'string' ? process.env.PUBLIC_URL : '';
  return trimmed.startsWith('/') ? `${publicUrl}${trimmed}` : `${publicUrl}/${trimmed}`;
}

// Helper function for fetch with auth
export const fetchWithAuth = async (endpoint, options = {}) => {
  const token = localStorage.getItem('admin_token') || localStorage.getItem('user_token');

  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers,
  });

  return response;
};
